import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';
import { BehaviorSubject } from 'rxjs';
import { AppGlobals } from '../app.globals';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private apiBase: ApiBaseService) {}

  public $accessToken = new BehaviorSubject<string>('');
  public $graphToken = new BehaviorSubject<string>('');

  async getUserDetails(payLoad: any): Promise<any> {
    return this.apiBase.httpRequest('AuthenticationService/GetUserDetails', payLoad, true, true);
  }

  async getUserDetailsFetch(payLoad: any): Promise<any> {
    return this.apiBase.fetchRequest('AuthenticationService/GetUserDetails', payLoad, true, true);
  }

  // with Tenant
  async getProjectUser(payLoad: any): Promise<any> {
    return this.apiBase.httpRequest('AuthenticationService/GetProjectUser', payLoad, true, true);
  }
}
